import React from 'react';
import styled from 'styled-components';

import Section from './global/section';
import ButtonLink from './global/button-link';

const BottomCtaStyle = styled.div`
	section {
		background-image: url(${(p) => p.bimg});
		background-position: right -4rem;
		background-size: 400px;
		background-repeat: no-repeat;
	}

	.flex {
		display: flex;
		padding: 1rem;
		h2 {
			flex: 0 0 ${(p) => p.textWidth};
			font-size: 3.25rem;
			padding-right: 2rem;
			span {
				color: ${(p) => p.theme.color[p.color]};
			}
		}
		div {
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
		}

		@media all and (max-width: 950px) {
			flex-direction: column;
			align-items: flex-start;
			text-align: ${(p) => p.align};
			h2 {
				margin-bottom: 2rem;
				flex: none;
				padding-right: 0;
			}
			div {
				justify-content: ${(p) => p.align};
			}
		}
		@media all and (max-width: 450px) {
			h2 {
				font-size: 2.5rem;
			}
		}
	}
`;

export default ({ text1, colored, text2, cta, bg, textWidth, bimg, align }) => {
	const alignProp = align === undefined ? 'flex-start' : align;
	return (
		<BottomCtaStyle
			align={alignProp}
			color={colored.color}
			textWidth={textWidth}
			bimg={bimg}
		>
			<Section bg={bg}>
				<div className="flex">
					<h2>
						{text1} <span>{colored.text}</span> {text2 && text2}
					</h2>
					<div>
						<ButtonLink to={cta.link} bg="dark" size="large">
							{cta.text}
						</ButtonLink>
					</div>
				</div>
			</Section>
		</BottomCtaStyle>
	);
};
